module.exports = __webpack_public_path__ + "static/media/topPos.36e38021.svg";